import { useMutation, useQueryClient } from '@tanstack/react-query';

import type AgentApiCandidateMailsRecord from '@/types/serializers/AgentApiCandidateMailsRecord';

export interface CreateCandidateMailRequest {
  subject: string;
  body: string;
  candidateProfileIds: number[];
  scheduledAt?: string;
}

export default function useCreateCandidateMail() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement)?.content ?? '';

  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['candidateMails'] }),
    mutationFn: async (
      params: CreateCandidateMailRequest
    ): Promise<AgentApiCandidateMailsRecord> => {
      const response = await fetch('/agent/api/candidate_mails', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          candidate_mail: {
            subject: params.subject,
            body: params.body,
            candidate_profile_ids: params.candidateProfileIds,
            ...(params.scheduledAt ? { scheduled_at: params.scheduledAt } : {}),
          },
        }),
      });

      if (!response.ok) {
        let message = '候補者メールの作成に失敗しました。';
        try {
          const data = await response.json();
          const serverMessage = data?.errors?.[0] ?? data?.message ?? data?.error;
          if (typeof serverMessage === 'string' && serverMessage.trim().length > 0) {
            message = serverMessage;
          }
        } catch (error) {
          console.error(error);
        }
        throw new Error(message);
      }

      return await response.json();
    },
  });
}
